import { render, staticRenderFns } from "./m-sidebar-shipping-costs.vue?vue&type=template&id=d3673434&"
import script from "./m-sidebar-shipping-costs.vue?vue&type=script&lang=js&"
export * from "./m-sidebar-shipping-costs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports